import {Plugin} from 'chart.js';

/**
 * Draws a 1px gold border *outside* bars that are at 100%,
 * so the bar's own width is not affected.
 */
export const invasionGoldBorderPlugin: Plugin<'bar'> = {
    id: 'invasionGoldBorder',
    afterDatasetsDraw(chart) {
        const {ctx} = chart;
        const dataset = chart.data.datasets[0];
        if (!dataset) return;
        const meta = chart.getDatasetMeta(0);

        meta.data.forEach((bar, index) => {
            const value = dataset.data[index] as number;
            if (value === 100) {
                const {x, y, base, width} = bar.getProps(
                    ['x', 'y', 'base', 'width'],
                    true
                );
                const half = width / 2;
                const pad = 1; // 1px outside the bar

                ctx.save();
                ctx.strokeStyle = '#FFD700';
                ctx.lineWidth = 1;
                ctx.strokeRect(
                    x - half - pad,
                    y - pad,
                    width + pad * 2,
                    base - y + pad * 2
                );
                ctx.restore();
            }
        });
    },
};
